module.exports = __webpack_public_path__ + "static/media/non_stop_10.8cd76288.png";